/*
 * Copyright (c)  2019 by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : $author
 *  date : 07/06/19 09:42
 */

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { AuthorizationService } from './authorization.service';
import { Router } from '@angular/router';
import { AppConfig } from '../engine/app-config';

@Injectable()
export class OAuthInterceptor implements HttpInterceptor {
  protected authentication = inject(AuthorizationService);
  protected router = inject(Router);
  protected config = inject(AppConfig);


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 ||
          (error.status === 408 && error.statusText === "User  doesn't exist")
        ) {
          if (this.router.url.indexOf(this.config.loginConfig.loginRoute) < 0) {
            this.authentication.saveRoute = this.router.url;
            this.authentication.logout();
          }
        }
        if (error.status === 403) {
          this.router.navigateByUrl('error/403').then();
        }
        return throwError(error);
      }),
    );
  }
}
